import React, { memo } from 'react';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './SeatChangeTable.scss';
import { IMAGE_URL } from '../../../../constants';

const getColorClass = change => {
  if (change > 0) return s.green;
  if (change < 0) return s.red;
  return s.defaultColor; // Assuming you have a default color defined in your CSS
};

const getChangeText = change => {
  if (change !== 0) return change > 0 ? `+${change}` : `${change}`;
  return '-';
};

const SeatChangeTable = ({
  currentYear,
  lastYear,
  parties,
  logo = false,
  isWapView = false,
  colorMap = {},
  activeSeats = 0,
  leadPlusWinCount = {},
  leadObject = {},
  partyView = true,
}) => (
  <div className={s.seatChangeTableWrap}>
    <div className={`${s.scTableRow} ${s.tableHead}`}>
      <div className={`${s.scTableCol}`}>
        {partyView ? 'Party' : 'Alliance'}
      </div>
      <div className={`${s.scTableCol}`}>{currentYear}</div>
      <div className={`${s.scTableCol}`}>{lastYear}</div>
      <div className={`${s.scTableCol}`}>Change{!isWapView && '(+/-)'}</div>
    </div>

    {parties &&
      Array.isArray(parties) &&
      parties.length > 0 &&
      parties.map((party, index) => (
        <div className={`${s.scTableRow}`}>
          <div
            className={`${s.scTableCol}`}
            style={{
              background:
                party.cc ||
                (colorMap?.[party.nm] && colorMap[party.nm].cc) ||
                '#bcbec0',
            }}
          >
            {logo && (
              <div className={s.partyLogo}>
                <ImageV2
                  src={`${IMAGE_URL}${party.lg ||
                    (colorMap?.[party.nm] && colorMap[party.nm].lg)}.cms`}
                  alt={party.an || party.nm}
                />
              </div>
            )}
            <div className={`${s.partyNameStatus} ${!logo ? s.noLogo : ''}`}>
              {party.an || party.nm}
              {index === 0 &&
              leadPlusWinCount?.winCount &&
              activeSeats &&
              leadPlusWinCount?.winCount === activeSeats &&
              leadObject.text === 'WON' ? (
                <p>Majority</p>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className={`${s.scTableCol}`}>{party.ws + party.ls}</div>
          <div className={`${s.scTableCol}`}>{party.pws}</div>
          <div
            className={`${s.scTableCol} ${getColorClass(
              party.ws + party.ls - party.pws,
            )}`}
          >
            {getChangeText(party.ws + party.ls - party.pws)}
          </div>
        </div>
      ))}
  </div>
);

export default memo(SeatChangeTable);
